import { render, staticRenderFns } from "./Architecture.vue?vue&type=template&id=211aa890&scoped=true&"
import script from "./Architecture.vue?vue&type=script&lang=js&"
export * from "./Architecture.vue?vue&type=script&lang=js&"
import style0 from "./Architecture.vue?vue&type=style&index=0&id=211aa890&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "211aa890",
  null
  
)

export default component.exports